module.exports = __webpack_public_path__ + "static/fonts/CoTextCorp-Regular.2e45c9a.woff2";